import {inject, PLATFORM_ID} from '@angular/core';
import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent
} from '@angular/common/http';
import {MinizaemApiClientService} from "../services/minizaem-api-client.service";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {isPlatformBrowser} from "@angular/common";

const AUTH_HEADER_URLS = [
  '/api/loan/show-current-for-customer',
  '/api/loan/action-permissions',
  '/api/loan-attachment/create',
  '/api/loan-attachment/show-by-loan',
  '/api/loan-attachment/are-modifications-allowed-for-loan',
  '/api/loan-attachment/delete',
  '/api/loan-attachment/show',
  '/api/loan/create',
  '/api/customer',
  '/api/customer/update',
  '/api/loan-extend-period-annex/is-new-allowed-for-loan',
  '/api/loan-extend-period-annex/create',
  '/api/loan-refinance-request/is-new-allowed-for-loan',
  '/api/loan-refinance-request/show-current-for-customer',
  '/api/loan-refinance-request/create',
  '/api/loan-refinance-request/init',
  '/api/loan-repayment-request/is-new-allowed-for-loan',
  '/api/loan-repayment-request/init-by-loan-and-repayment-date',
  '/api/loan-repayment-request/create',
  '/api/video-room/show-by-loan',
  '/api/video-room/generate-access-token',
  '/api/iris/payment-link/create',
  '/api/iris/bank-account/customer/signup',
  '/api/iris/bank-account/consent/create',
  '/api/iris/bank-account/get-banks'
];

export function authHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  let minizaemApiClientService = inject(MinizaemApiClientService);
  let platformId = inject(PLATFORM_ID);

  const jwt = minizaemApiClientService.getJwt();
  const shouldAddAuthHeader =
    isPlatformBrowser(platformId) &&
    req.url.includes(environment.minizaemApiDomain) &&
    AUTH_HEADER_URLS.some((url) => req.url.includes(url));

  let headers = {};
  if (shouldAddAuthHeader) {
    headers = {
      headers: req.headers.append('Authorization', `Bearer ${jwt}`)
    };
  }
  const authReq = req.clone(headers);

  // send cloned request with header to the next handler.
  return next(authReq);
}
